export const postCodeValidator = (value) => {
    if ((/^[A-Za-z0-9]{1,7}$/).test(value)) {
        return true
    } else { return false }
}